import {  postPhoneSendOtp } from "../../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_send_phone_otpThunk = createAsyncThunk(
  "reKyc_send_phone_otpThunk",
  async ({ params, token }) => {
    try {
      const response = postPhoneSendOtp(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
